import { render, staticRenderFns } from "./Day.vue?vue&type=template&id=970934b2&scoped=true&"
import script from "./Day.vue?vue&type=script&lang=js&"
export * from "./Day.vue?vue&type=script&lang=js&"
import style0 from "./Day.vue?vue&type=style&index=0&id=970934b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970934b2",
  null
  
)

export default component.exports